import { lazy, Suspense } from 'react';

import { Route, Routes } from 'react-router-dom';

import RouteAuth from '../../core/security/routeAuth';
import { Role } from '../Security/models/Authorization';

import { TaxreturnReview } from './TaxReturnEvaluation/components/review';
import { ApproveTaxreturn } from './TaxReturnEvaluation/pages/approve';
import { RejectTaxreturn } from './TaxReturnEvaluation/pages/reject';

const TaxReturnEvaluation = lazy(() => import('./TaxReturnEvaluation/pages/evaluation'));

export const StatementRouting = () => {
  return (
    <Routes>
      <Route
        path="taxreturn-evaluation"
        element={
          <RouteAuth access={[Role.TaxreturnApprover]}>
            <Suspense fallback={<></>}>
              <TaxReturnEvaluation />
            </Suspense>
          </RouteAuth>
        }
      />
      <Route
        path="taxreturn-evaluation/:id"
        element={
          <RouteAuth access={[Role.TaxreturnApprover]}>
            <TaxreturnReview />
          </RouteAuth>
        }
      />
      <Route
        path="approve-taxreturn/:id"
        element={
          <RouteAuth access={[Role.TaxreturnApprover]}>
            <ApproveTaxreturn />
          </RouteAuth>
        }
      />
      <Route
        path="reject-taxreturn/:id"
        element={
          <RouteAuth access={[Role.TaxreturnApprover]}>
            <RejectTaxreturn />
          </RouteAuth>
        }
      />
    </Routes>
  );
};
